module.exports = {"152529100":"明安图镇","152529101":"星耀镇","152529200":"伊和淖尔苏木","152529201":"乌兰查布苏木","152529202":"宝拉根陶海苏木","152529500":"额里图种畜场","152529502":"哲日根图林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/152529.json
// module id = 492
// module chunks = 0